import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContainerState {
  [key: string]: {
    position: number
  }
}

const defaultState: ContainerState = {}

export const containerSlice = createSlice({
  name: 'container',
  initialState: defaultState,
  reducers: {
    setDividerPosition: (state, action: PayloadAction<{ id: string; position: number }>) => {
      const { id, position } = action.payload
      state[id] = { position }
    }
  }
})

export const { setDividerPosition } = containerSlice.actions

export { defaultState as containerDefaultState }
export default containerSlice.reducer
